export const getLocalizedValue = (viewMode, adminFrValue, adminEnValue, clientFrValue, clientEnValue) => {
    if (viewMode === 'client_fr')
        return clientFrValue || adminFrValue || '';
    if (viewMode === 'client_en')
        return clientEnValue || adminEnValue || '';
    if (viewMode === 'admin_en')
        return adminEnValue || adminFrValue || '';
    return adminFrValue || '';
};
